const presentacion = {
    titulo: `Seleccione aquí el tema a practicar - funciones`,
    problemas: [
      {
        codigo:1,
        descripcion: `El objetivo de este tutorial interactivo es practicar el lenguaje JavaScript con el tema de funciones.
Se mostrará un problema que debera ser analizado e ingresar la salida que genera en pantalla (Ingresamos con comillas si hay una salida de un string, sin comillas si es
un número, entre corchetes si es un arreglo, entre llaves si es un objeto, o el texto error si cree que la sintaxis es incorrecta, etc.)
Por ejemplo si ejecutamos el programa console.log("Hola mundo") luego en el cuadro de entrada debemos ingresar "Hola mundo" y presionar el botón de Verificar (con simple o doble comillas)`,
        programa: `console.log("Hola mundo")`,
        solucion: "\"Hola mundo\""
      },
      {
        codigo:2,
        descripcion: `Si sumamos 2 enteros y mostramos una variable numérica (debemos ingresar directamente el número sin comillas)`,
        programa: `const valor1 = 10
const valor2 = 20
const suma = valor1 + valor2
console.log(suma)`,
        solucion: "30"
      },
      {
        codigo:3,
        descripcion: `Debe ingresar el texto error si la sintaxis del algoritmo lo cree incorrecto como el siguiente ejemplo:`,
        programa: `const valor = 10
valor=20`,
        solucion: ""
      }
    ]
  }

export default presentacion;